import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  Typography,
  CssBaseline,
  Container,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Grid,
} from "@material-ui/core";

import ValidationsContext from "context/validations/validationsContext";
import AuthContext from "context/autentication/authContext";
import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { MdVisibility, MdVisibilityOff, MdHelp } from "react-icons/md";
import InputMask from "react-input-mask";
import Popover from "@material-ui/core/Popover";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Role } from "types/roles";

const useStyles = makeStyles((theme) => ({
  step: {
    width: "10%",
    display: "flex",
    flexDirection: "row",
    padding: "0px 1em 0px 0px",
    marginLeft: "65%",
    fontSize: "30px",
  },
  root: {
    backgroundColor: "#fafafa",
    border: "1px solid #c1bfbf",
    boxShadow: "0",
    elevation: 0,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  help: {
    height: "2em",
    width: "2em",
    position: "absolute",
    top: "-2.5em",
    right: "-2em",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    display: "flex",
    height: "100%",
    flexDirection: "row-reverse",
    position: "relative",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formInputs: {
    width: "73.333333%",
    height: "100%",
  },
  formTelefonos: {
    width: "33.33333333%",
    height: "100%",
    marginLeft: "1.2em",
    padding: "0em 1em 1em 1em",
  },
  telList: {
    height: "50%",
    maxHeight: "30vh",
    width: "100%",
    marginRight: "0px",
    marginLeft: "1em",
    paddingBottom: "1em",
    paddingRight: "0px",
    paddingTop: "0px",
  },
  telListPaper: {
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    marginRight: "0px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
}));

export default function Formulario({
  errorCliente,
  handleNext,
  handleBack,
  cliente,
}) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const { rol } = authContext;
  const validationsContext = useContext(ValidationsContext);
  const {
    validateForm,
    validateUsername,
    validateeMail,
    validateDirecciones,
    validateCuit,
    validatePassword,
    validateRepeatPassword,
  } = validationsContext;
  const [state, setState] = useState({
    email: cliente.email ? cliente.email : "",
    nombre: cliente.nombre ? cliente.nombre : "",
    password: cliente.password ? cliente.password : "",
    password2: "",
    rol: rol === Role.Super ? "" : Role.Admin,
    codigoPais: "+549",
    codigoArea: cliente.codigoArea ? cliente.codigoArea : "",
    numeroTelefono: cliente.numeroTelefono ? cliente.numeroTelefono : "",
    showPassword: false,
  });
  ////pasos step
  function getSteps() {
    return [" ", " ", " ", " "];
  }
  const steps = getSteps();
  ///fin step

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [anchorElEmail, setAnchorElEmail] = React.useState(null);

  const handleClickEmail = (event) => {
    setAnchorElEmail(event.currentTarget);
  };

  const handleCloseEmail = () => {
    setAnchorElEmail(null);
  };

  const openEmail = Boolean(anchorElEmail);
  const idEmail = openEmail ? "simple-popover" : undefined;
  const isFormIncomplete = () => {
    return (
      state.nombre.trim() === "" ||
      state.email.trim() === "" ||
      state.password.trim() === "" ||
      state.password2.trim() === "" ||
      state.rol.trim() === "" ||
      state.codigoPais.trim() === "" ||
      state.codigoArea.trim() === "" ||
      state.numeroTelefono.trim() === ""
    );
  };
  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    setErrors({
      cuit: "",
      razonSocial: "",
      nombre: "",
      paisSelect: "",
      provinciaSelect: "",
      localidad: "",
      direccion: "",
      email: "",
      password: "",
      password2: "",
      codigoArea: "",
      numeroTelefono: "",
    });
    // eslint-disable-next-line
  }, []);

  const [errors, setErrors] = useState({
    cuit: "",
    razonSocial: "",
    nombre: "",
    paisSelect: "",
    provinciaSelect: "",
    localidad: "",
    direccion: "",
    email: "",
    password: "",
    password2: "",
    codigoPais: "+549",
    codigoArea: "",
    numeroTelefono: "",
  });
  const onChangeRol = (e) => {
    setState({
      ...state,
      rol: e.target.value,
    });
  };
  const onChange = (e) => {
    // cargo el preview
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    switch (e.target.name) {
      case "nombre":
        setErrors({
          ...errors,
          nombre: validateUsername(e.target.value),
        });
        break;
      case "razonSocial":
        setErrors({
          ...errors,
          razonSocial: validateUsername(e.target.value),
        });
        break;
      case "direccion":
        setErrors({
          ...errors,
          direccion: validateDirecciones(e.target.value),
        });
        break;
      case "email":
        setErrors({
          ...errors,
          email: validateeMail(e.target.value),
        });
        break;
      case "password":
        setErrors({
          ...errors,
          password: validatePassword(e.target.value),
          password2: validateRepeatPassword(state.password, e.target.value),
        });
        break;
      case "password2":
        setErrors({
          ...errors,
          password2: validateRepeatPassword(e.target.value, state.password),
        });
        break;
      case "cuit":
        setErrors({
          ...errors,
          cuit: validateCuit(e.target.value),
        });
        break;
      default:
        break;
    }
  };
  // Cuando el usuario guardar o actualizar la localidad
  const onSubmit = (e) => {
    e.preventDefault();
    // Validar que no haya campos vacios
    if (!validateForm(errors) || isFormIncomplete()) {
      errorCliente("Todos los campos con * son obligatorios", "error");
    } else {
      setErrors({
        cuit: "",
        razonSocial: "",
        nombre: "",
        paisSelect: "",
        provinciaSelect: "",
        localidad: "",
        direccion: "",
        email: "",
        password: "",
        password2: "",
        codigoArea: "",
        numeroTelefono: "",
      });
    }
  };

  return (
    <div style={{ width: "550px" }}>
      <Stepper
        nonLinear
        activeStep={2}
        className={classes.step}
        style={{ backgroundColor: "#fafafa" }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton style={{ cursor: "default" }}>{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <CssBaseline />
      <div
        className={classes.form}
        noValidate
        onSubmit={onSubmit}
        autoComplete="off"
      >
        {/* <div className={classes.help}>
                    <Help info={"el telefono de contacto es el que será mostrado a la policia en caso de alerta"} />
                </div> */}
        <Grid container justify="space-around" alignItems="center" spacing={1}>
          <Grid item xs={12}>
            <TextField
              error={errors.nombre.length > 0}
              variant="outlined"
              margin="normal"
              id="nombre"
              name="nombre"
              type="text"
              required
              fullWidth
              label={
                errors.nombre.length > 0 ? errors.nombre : "Nombre Usuario"
              }
              value={state.nombre}
              onChange={onChange}
            />
          </Grid>
          {/*  <Grid item xs={4} md={2} lg={2}>
                        <TextField margin="normal" id="standard-required" label="Cod. Pais" defaultValue="+549" variant="outlined" InputProps={{
                            readOnly: true,
                        }} />
                    </Grid> */}
          <Grid item xs={12} md={6} lg={6}>
            <InputMask
              maskChar=""
              mask="\09999"
              value={state.codigoArea}
              onChange={onChange}
            >
              {() => (
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="codigoArea"
                  label={"Codigo Area"}
                  id="codigoArea"
                  type="text"
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12} md={6} lg={6} style={{ marginTop: "5px" }}>
            <InputMask
              maskChar=""
              mask="1\599999999"
              value={state.numeroTelefono}
              onChange={onChange}
            >
              {() => (
                <OutlinedInput
                  variant="outlined"
                  required
                  fullWidth
                  name="numeroTelefono"
                  id="numeroTelefono"
                  type="text"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle email visibility"
                        onClick={handleClick}
                        edge="end"
                      >
                        <MdHelp />
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={170}
                />
              )}
            </InputMask>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <Typography className={classes.typography}>
                Aseguresé de ingresarlo correctamente, caso contario no podra
                recibir alertas via SMS
              </Typography>
            </Popover>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <FormControl /* className={clsx(classes.margin, classes.textField)} */
              required
              fullWidth
              variant="outlined"
            >
              {errors.email.length > 0 ? (
                <InputLabel
                  htmlFor="outlined-adornment-email"
                  style={{ color: "red" }}
                >
                  {errors.email.length > 0 ? errors.email : "Email"}
                </InputLabel>
              ) : (
                <InputLabel htmlFor="outlined-adornment-email">
                  Email
                </InputLabel>
              )}
              <OutlinedInput
                error={errors.email.length > 0}
                id="outlined-adornment-email"
                type="text"
                margin="normal"
                required
                fullWidth
                name="email"
                value={state.email}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle email visibility"
                      onClick={handleClickEmail}
                      edge="end"
                    >
                      <MdHelp />
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={70}
              />
              <Popover
                id={idEmail}
                open={openEmail}
                anchorEl={anchorElEmail}
                onClose={handleCloseEmail}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Typography className={classes.typography}>
                  The content of the Popover.
                </Typography>
              </Popover>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <FormControl variant="outlined" margin="normal" required fullWidth>
              {errors.password.length > 0 ? (
                <InputLabel
                  htmlFor="outlined-adornment-password"
                  style={{ color: "red" }}
                >
                  {errors.password.length > 0 ? errors.password : "Contraseña"}
                </InputLabel>
              ) : (
                <InputLabel htmlFor="outlined-adornment-password">
                  Contraseña
                </InputLabel>
              )}
              <OutlinedInput
                error={errors.password.length > 0}
                margin="normal"
                required
                fullWidth
                id="password"
                label={
                  errors.password.length > 0 ? errors.password : "Contraseña"
                }
                name="password"
                id="outlined-adornment-password"
                type={state.showPassword ? "text" : "password"}
                value={state.password}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {state.showPassword ? (
                        <MdVisibility />
                      ) : (
                        <MdVisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <FormControl variant="outlined" margin="normal" required fullWidth>
              {errors.password2.length > 0 ? (
                <InputLabel
                  htmlFor="outlined-adornment-password"
                  style={{ color: "red" }}
                >
                  {errors.password2.length > 0
                    ? errors.password2
                    : "Contraseña"}
                </InputLabel>
              ) : (
                <InputLabel htmlFor="outlined-adornment-password">
                  Repita la contraseña
                </InputLabel>
              )}
              <OutlinedInput
                error={errors.password2.length > 0}
                margin="normal"
                required
                fullWidth
                id="password2"
                label={
                  errors.password2.length > 0
                    ? errors.password2
                    : "Repita la contraseña"
                }
                name="password2"
                id="outlined-adornment-password"
                type={state.showPassword ? "text" : "password"}
                value={state.password2}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {state.showPassword ? (
                        <MdVisibility />
                      ) : (
                        <MdVisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {rol === Role.Super && (
              <FormControl variant="outlined" fullWidth margin="normal">
                <InputLabel id="pais-label">Rol</InputLabel>
                <Select
                  error={!state.rol}
                  labelId="demo-simple-select-outlined-label"
                  id="rol"
                  name="rol"
                  value={state.rol}
                  onChange={onChangeRol}
                  label="Rol"
                  defaultValue={""}
                >
                  <MenuItem key={0} value={Role.Supervisor}>
                    Supervisor
                  </MenuItem>
                  <MenuItem key={1} value={Role.Integrador}>
                    Integrador
                  </MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid item xs={6}>
            <Grid item xs={10} md={10} lg={10}>
              <Button
                mx="auto"
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => handleBack()}
                style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
              >
                Volver
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container justify="flex-end">
              <Grid item xs={10} md={10} lg={10}>
                {isFormIncomplete() || !validateForm(errors) ? (
                  <Button
                    mx="auto"
                    type="submit"
                    disabled
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Siguiente
                  </Button>
                ) : (
                  <Button
                    mx="auto"
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => handleNext(state)}
                    style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
                  >
                    Siguiente
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
